import { makeStyles } from '@material-ui/core';

export const styles = makeStyles((theme) => ({
  toolbar: {
    minHeight: '20px',
    height: '20px',
  },
}));
